import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl, IntlShape } from 'react-intl';
import { get } from 'lodash';
import { sanlamDarkBlue } from 'Material-UI/colors';

import { translate } from 'helpers/intl';
import ContainerTabs from 'components/ContainerTabs';
import Breadcrumbs from 'components/Breadcrumbs';
import {
  StyledMediumSectionHeader,
  StyledCaptions,
} from 'containers/AsiDetailsPage/styles';
import {
  getASIDetailsPageBreadcrumbsPathSelector,
  getASIDetailsPageSelectedTabValue,
  getASIFaqSelector,
} from 'store/global/selectors';
import { breadcrumbsItemType } from 'store/global/types';
import { setASIDetailsPageBreadcrumbsPath, getFaq } from 'store/global/actions';
import messages from 'containers/AsiDetailsPage/messages';
import FrequentlyAskedQuestions from 'containers/AUTODashboard/Body/FrequentlyAskedQuestions';
import MyContractAndGarantiesTab from 'containers/AsiDetailsPage/MyContractAndGarantiesTab';
import ServicesBloc from 'containers/AsiDetailsPage/ServicesBlock';
import MyRefundsTab from 'containers/AsiDetailsPage/MyRefundsTab';
import MyOffers from 'containers/AsiDetailsPage/MyOffers';
import DetailPageLayout from 'components/DetailPageLayout';
import HeaderImage from 'images/header-asi.png';
import { StyledShortBody } from 'containers/AUTODashboard/Body/FrequentlyAskedQuestions/styles';
import PAGES from 'routes/pages';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import { getContractASISelector } from 'store/contract/selectors';
import { getContratsASI } from 'store/contract/actions';

const tabItems = (contractASI: {}) => [
  {
    label: 'mesRemboursements',
    content: <MyRefundsTab />,
  },
  {
    label: 'contractEtGarantie',
    content: <MyContractAndGarantiesTab contractASI={contractASI} />,
  },
];

const AsiDetailsPage = (props: {
  detailsPageBreadcrumbsPath: breadcrumbsItemType[];
  setASIDetailsPageBreadcrumbsPath: Function;
  intl: IntlShape;
  selectedTabValue: number;
  getFaq: Function;
  faq: [];
  contractsASI: {};
  getContratsASI: Function;
}) => {
  const language = useSelector(getLocaleSelector);
  useEffect(() => {
    props.getFaq(language);
    props.getContratsASI({ language });
    // eslint-disable-next-line
  }, [language]);

  const HeaderTextBloc = (
    <>
      <StyledMediumSectionHeader>
        {translate(get(messages, 'title'), props)}
      </StyledMediumSectionHeader>
      <StyledCaptions>
        {translate(get(messages, 'subTitle'), props)}
      </StyledCaptions>
    </>
  );
  return (
    <DetailPageLayout
      headerImage={HeaderImage}
      HeaderTextBloc={HeaderTextBloc}
      Breadcrumbs={
        <Breadcrumbs
          path={props.detailsPageBreadcrumbsPath}
          setBreadcrumbsPath={props.setASIDetailsPageBreadcrumbsPath}
        />
      }
      TabsBloc={
        <ContainerTabs
          tabItems={tabItems(props.contractsASI)}
          setBreadcrumbsPath={props.setASIDetailsPageBreadcrumbsPath}
          rootPath={[{ name: 'asi', route: PAGES.ASI_DASHBOARD }]}
          selectedTabValue={props.selectedTabValue}
        />
      }
      FAQBloc={
        <FrequentlyAskedQuestions
          items={
            props.faq &&
            props.faq.map(
              (
                item: { question: string; code: string; id: number },
                index: number,
              ) => ({
                title: (
                  <StyledShortBody
                    weight="bold"
                    color={sanlamDarkBlue}
                    key={index}
                  >
                    {item.question}
                  </StyledShortBody>
                ),
                path: PAGES.FAQ,
                id: item.id,
                code: item.code,
                isFaq: true,
              }),
            )
          }
          GACategoryAllResponses={EVENT_CATEGORIES.ASI_DETAILS}
        />
      }
      CompensationServicesBloc={<></>}
      ServiceBloc={<ServicesBloc />}
      MyOffersBloc={<MyOffers />}
    />
  );
};

const mapStateToProps = createStructuredSelector<
  any,
  {
    detailsPageBreadcrumbsPath: breadcrumbsItemType[];
    selectedTabValue: number;
    faq: [];
    contractsASI: [];
  }
>({
  detailsPageBreadcrumbsPath: getASIDetailsPageBreadcrumbsPathSelector,
  selectedTabValue: getASIDetailsPageSelectedTabValue,
  faq: getASIFaqSelector,
  contractsASI: getContractASISelector,
});
const mapDispatchToProps = {
  setASIDetailsPageBreadcrumbsPath,
  getFaq,
  getContratsASI,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(AsiDetailsPage));
export { AsiDetailsPage as AsiDetailsPageTest };
